// src/models/functionError.ts
/**
* Type guard to check if an error has the FirebaseFunctionError structure
* This ensures type safety when handling errors from "Firebase Functions
*/
function isFirebaseFunctionError(error) {
	return typeof error === "object" && error !== null && ("code" in error || "message" in error || "details" in error);
}

export { isFirebaseFunctionError };
//# sourceMappingURL=functionError.mjs.map